// STT protocol versions that use the latest score scale (must match LatestProtocolIds in GaitReport.cs / RunningAnalysisReport.cs)
export const LatestProtocolIds: string[] = ['2026.0', '2026.1'];

export function isLatestProtocol(protocolId: string): boolean {
  return LatestProtocolIds.includes(protocolId);
}
